import { useMutation } from '@tanstack/react-query'

import type { Language } from '@/api/v1/administration/profile/update-language/update-language.types'
import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { CreateEnvelopeAiChatResponse } from './ai-chat.types'

interface CreateEnvelopeAiChatParams {
  envelopeId: string
  language: Language
}

const createEnvelopeAiChat = async (
  params: CreateEnvelopeAiChatParams,
): Promise<CreateEnvelopeAiChatResponse> => {
  const response = await apiClient.post<CreateEnvelopeAiChatResponse>(
    `/v1/ecm/envelopes/${params.envelopeId}/ai-chat`,
    { language: params.language },
  )
  return response.data
}

export const useCreateEnvelopeAiChat = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (params: CreateEnvelopeAiChatParams) =>
      createEnvelopeAiChat(params),
    meta: { ...feedback },
  })
}
